(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["article"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-article-template]').forEach((section) => {
    const content = section.querySelector('[data-article-content]')
    if (!content) return

    content.querySelectorAll('table').forEach((table) => {
      if (table.parentElement && table.parentElement.classList.contains('article-template__table-wrap')) return
      const wrapper = document.createElement('div')
      wrapper.className = 'article-template__table-wrap'
      table.parentNode.insertBefore(wrapper, table)
      wrapper.appendChild(table)
    })

    content.querySelectorAll('iframe').forEach((iframe) => {
      if (iframe.parentElement && iframe.parentElement.classList.contains('article-template__embed-wrap')) return
      const wrapper = document.createElement('div')
      wrapper.className = 'article-template__embed-wrap'
      iframe.parentNode.insertBefore(wrapper, iframe)
      wrapper.appendChild(iframe)
    })

    content.querySelectorAll('a[href^="http"]').forEach((link) => {
      if (link.hostname === window.location.hostname) return
      link.setAttribute('target', '_blank')
      link.setAttribute('rel', 'noopener noreferrer')
    })

    if (section.dataset.enableToc === 'true') {
      const toc = section.querySelector('[data-article-toc]')
      const tocList = section.querySelector('[data-article-toc-list]')
      const headings = Array.from(content.querySelectorAll('h2, h3')).filter((heading) => heading.textContent.trim())

      if (toc && tocList && headings.length > 0) {
        headings.forEach((heading, index) => {
          if (!heading.id) {
            heading.id = `article-heading-${index + 1}`
          }

          const link = document.createElement('a')
          link.href = `#${heading.id}`
          link.dataset.level = heading.tagName
          link.textContent = heading.textContent.trim()
          tocList.appendChild(link)
        })

        toc.hidden = false
      }
    }

    section.querySelectorAll('[data-copy-article-link]').forEach((button) => {
      button.addEventListener('click', async () => {
        try {
          await navigator.clipboard.writeText(window.location.href)
          button.classList.add('is-copied')
          setTimeout(() => button.classList.remove('is-copied'), 1600)
        } catch (error) {
          window.prompt(section.dataset.copyPrompt || '', window.location.href)
        }
      })
    })
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var toggles = document.querySelectorAll('[data-collection-filter-toggle]');

    toggles.forEach(function (toggle) {
      var filters = document.getElementById(toggle.getAttribute('aria-controls'));
      if (!filters) return;

      toggle.addEventListener('click', function () {
        var isOpen = filters.classList.toggle('is-open');
        toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-categories"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-featured-categories-section]').forEach((section) => {
    const track = section.querySelector('[data-featured-categories-track]')
    const prevButton = section.querySelector('[data-featured-categories-prev]')
    const nextButton = section.querySelector('[data-featured-categories-next]')

    if (!track || !prevButton || !nextButton) return

    const getStep = () => {
      const firstItem = track.querySelector('.featured-categories__card')
      if (!firstItem) return 0

      const gap = Number.parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap || '0')
      return firstItem.getBoundingClientRect().width + gap
    }

    function updateState() {
      const atStart = track.scrollLeft <= 0
      const atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 1
      prevButton.disabled = atStart
      nextButton.disabled = atEnd
    }

    prevButton.addEventListener('click', () => {
      track.scrollBy({ left: -getStep(), behavior: 'smooth' })
    })

    nextButton.addEventListener('click', () => {
      track.scrollBy({ left: getStep(), behavior: 'smooth' })
    })

    let scrollTicking = false
    track.addEventListener('scroll', () => {
      if (!scrollTicking) {
        requestAnimationFrame(() => {
          updateState()
          scrollTicking = false
        })
        scrollTicking = true
      }
    })

    updateState()
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-products"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-featured-products-section]').forEach((section) => {
    const track = section.querySelector('[data-featured-products-track]')
    const prevButton = section.querySelector('[data-featured-products-prev]')
    const nextButton = section.querySelector('[data-featured-products-next]')

    if (!track || !prevButton || !nextButton) return

    const getStep = () => {
      const firstItem = track.querySelector('.featured-products__item')
      if (!firstItem) return 0

      const gap = Number.parseFloat(getComputedStyle(track).gap || '0')
      return firstItem.getBoundingClientRect().width + gap
    }

    function updateState() {
      const atStart = track.scrollLeft <= 0
      const atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 1
      prevButton.disabled = atStart
      nextButton.disabled = atEnd
    }

    prevButton.addEventListener('click', () => {
      track.scrollBy({ left: -getStep(), behavior: 'smooth' })
    })

    nextButton.addEventListener('click', () => {
      track.scrollBy({ left: getStep(), behavior: 'smooth' })
    })

    let scrollTicking = false
    track.addEventListener('scroll', () => {
      if (!scrollTicking) {
        requestAnimationFrame(() => {
          updateState()
          scrollTicking = false
        })
        scrollTicking = true
      }
    })

    updateState()
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (function () {
    var input = document.getElementById('site-search-input');
    if (input && input.value.trim() === '') {
      var prefix = 'Search for ';
      var terms = [
        'cable pullers...',
        'threading machines...',
        'hydraulic benders...',
        'gangboxes...',
        'material lifts...',
        'wire & conduit...',
        'pipe cutters...',
        'hoists & rigging...',
        'hand benders...',
        'reel stands...'
      ];

      var phraseIndex = 0;
      var charIndex = 0;
      var isDeleting = false;
      var paused = false;
      var timer = null;

      function tick() {
        if (paused) return;

        var current = terms[phraseIndex];

        if (isDeleting) {
          charIndex--;
        } else {
          charIndex++;
        }

        input.setAttribute('placeholder', prefix + current.slice(0, charIndex));

        var delay;
        if (!isDeleting && charIndex === current.length) {
          isDeleting = true;
          delay = 1800;
        } else if (isDeleting && charIndex === 0) {
          isDeleting = false;
          phraseIndex = (phraseIndex + 1) % terms.length;
          delay = 400;
        } else {
          delay = isDeleting ? 40 : 70;
        }

        timer = setTimeout(tick, delay);
      }

      timer = setTimeout(tick, 900);

      input.addEventListener('focus', function () {
        paused = true;
        clearTimeout(timer);
        input.setAttribute('placeholder', '');
      });

      input.addEventListener('blur', function () {
        if (input.value.trim() === '') {
          charIndex = 0;
          isDeleting = false;
          paused = false;
          timer = setTimeout(tick, 500);
        }
      });
    }

    if (customElements.get('predictive-search')) return;

    class PredictiveSearch extends HTMLElement {
      constructor() {
        super();
        this.input = this.querySelector('input[type="search"]');
        this.panel = this.querySelector('[data-predictive-search-panel]');
        this.searchUrl = this.dataset.searchUrl || '/search/suggest';
        this.sectionId = this.dataset.sectionId || 'predictive-search';
        this.cache = {};
        this.abortController = null;
        this.debouncedInput = this.debounce(this.onInput.bind(this), 250);

        if (!this.input || !this.panel) return;

        this.input.addEventListener('input', this.debouncedInput);
        this.input.addEventListener('focus', this.onInput.bind(this));
        this.input.addEventListener('keydown', this.onKeydown.bind(this));
        this.panel.addEventListener('click', this.onPanelClick.bind(this));
        this.panel.addEventListener('keydown', this.onPanelKeydown.bind(this));
        document.addEventListener('click', this.onDocumentClick.bind(this));
      }

      onInput() {
        var searchTerm = this.input.value.trim();

        if (searchTerm.length < 2) {
          this.close();
          return;
        }

        this.getSearchResults(searchTerm);
      }

      onKeydown(event) {
        if (event.key === 'Escape') {
          this.close();
          this.input.focus();
          return;
        }

        if (event.key !== 'ArrowDown') return;

        var firstResult = this.panel.querySelector('.predictive-search__link');
        if (!firstResult || this.panel.hidden) return;

        event.preventDefault();
        firstResult.focus();
      }

      onPanelClick(event) {
        if (event.target.closest('[data-predictive-search-close]')) {
          event.preventDefault();
          this.close();
          this.input.focus();
        }
      }

      onPanelKeydown(event) {
        if (event.key === 'Escape') {
          this.close();
          this.input.focus();
          return;
        }

        if (event.key !== 'ArrowDown' && event.key !== 'ArrowUp' && event.key !== 'Home' && event.key !== 'End') return;

        var results = Array.prototype.slice.call(this.panel.querySelectorAll('.predictive-search__link'));
        var currentIndex = results.indexOf(document.activeElement);
        var nextIndex = currentIndex;

        if (!results.length) return;

        event.preventDefault();

        if (event.key === 'Home') {
          nextIndex = 0;
        } else if (event.key === 'End') {
          nextIndex = results.length - 1;
        } else if (event.key === 'ArrowDown') {
          nextIndex = currentIndex >= results.length - 1 ? 0 : currentIndex + 1;
        } else if (event.key === 'ArrowUp') {
          nextIndex = currentIndex <= 0 ? results.length - 1 : currentIndex - 1;
        }

        results[nextIndex].focus();
      }

      onDocumentClick(event) {
        if (this.contains(event.target)) return;

        this.close();
      }

      getSearchResults(searchTerm) {
        var cacheKey = searchTerm.toLowerCase();

        if (this.cache[cacheKey]) {
          this.renderResults(this.cache[cacheKey]);
          return;
        }

        if (this.abortController) {
          this.abortController.abort();
        }

        this.abortController = new AbortController();

        var params = new URLSearchParams();
        params.set('q', searchTerm);
        params.set('resources[type]', 'product');
        params.set('resources[limit]', '5');
        params.set('resources[limit_scope]', 'each');
        params.set('resources[options][unavailable_products]', 'last');
        params.set('resources[options][fields]', 'title,product_type,variants.title,vendor,variants.sku');
        params.set('section_id', this.sectionId);

        fetch(this.searchUrl + '?' + params.toString(), {
          signal: this.abortController.signal,
          headers: {
            'X-Requested-With': 'XMLHttpRequest'
          }
        })
          .then(function (response) {
            if (!response.ok) throw new Error(response.status);
            return response.text();
          })
          .then(function (text) {
            var section = new DOMParser()
              .parseFromString(text, 'text/html')
              .querySelector('#shopify-section-' + this.sectionId);
            var markup = section ? section.innerHTML.trim() : '';

            this.cache[cacheKey] = markup;
            this.renderResults(markup);
          }.bind(this))
          .catch(function (error) {
            if (error.name === 'AbortError') return;

            this.close();
          }.bind(this));
      }

      renderResults(markup) {
        if (!markup) {
          this.close();
          return;
        }

        this.panel.innerHTML = markup;
        this.open();
      }

      open() {
        this.panel.hidden = false;
        this.input.setAttribute('aria-expanded', 'true');
      }

      close() {
        this.panel.hidden = true;
        this.input.setAttribute('aria-expanded', 'false');
      }

      debounce(fn, wait) {
        var timeout;

        return function () {
          var args = arguments;

          clearTimeout(timeout);
          timeout = setTimeout(function () {
            fn.apply(this, args);
          }.bind(this), wait);
        }.bind(this);
      }
    }

    customElements.define('predictive-search', PredictiveSearch);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-compare"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-image-compare-section]').forEach((section) => {
    const range = section.querySelector('[data-image-compare-range]')

    if (!range) return

    function setPosition(value) {
      section.style.setProperty('--image-compare-position', `${value}%`)
    }

    range.addEventListener('input', (event) => {
      setPosition(event.target.value)
    })

    setPosition(range.value)
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-page-template]').forEach((section) => {
    const content = section.querySelector('[data-page-content]')
    if (!content) return

    content.querySelectorAll('table').forEach((table) => {
      if (table.parentElement && table.parentElement.classList.contains('page-template__table-wrap')) return
      const wrapper = document.createElement('div')
      wrapper.className = 'page-template__table-wrap'
      table.parentNode.insertBefore(wrapper, table)
      wrapper.appendChild(table)
    })

    content.querySelectorAll('iframe').forEach((iframe) => {
      if (iframe.parentElement && iframe.parentElement.classList.contains('page-template__embed-wrap')) return
      const wrapper = document.createElement('div')
      wrapper.className = 'page-template__embed-wrap'
      iframe.parentNode.insertBefore(wrapper, iframe)
      wrapper.appendChild(iframe)
    })

    content.querySelectorAll('a[href^="http"]').forEach((link) => {
      if (link.hostname === window.location.hostname) return
      link.setAttribute('target', '_blank')
      link.setAttribute('rel', 'noopener noreferrer')
    })

    if (section.dataset.enableToc === 'true') {
      const toc = section.querySelector('[data-page-toc]')
      const tocList = section.querySelector('[data-page-toc-list]')
      const headings = Array.from(content.querySelectorAll('h2, h3')).filter((heading) => heading.textContent.trim())

      if (toc && tocList && headings.length > 0) {
        headings.forEach((heading, index) => {
          if (!heading.id) {
            heading.id = `page-heading-${index + 1}`
          }

          const link = document.createElement('a')
          link.href = `#${heading.id}`
          link.dataset.level = heading.tagName
          link.textContent = heading.textContent.trim()
          tocList.appendChild(link)
        })

        toc.hidden = false
      }
    }

    section.querySelectorAll('[data-copy-page-link]').forEach((button) => {
      button.addEventListener('click', async () => {
        try {
          await navigator.clipboard.writeText(window.location.href)
          button.classList.add('is-copied')
          setTimeout(() => button.classList.remove('is-copied'), 1600)
        } catch (error) {
          window.prompt(section.dataset.copyPrompt || '', window.location.href)
        }
      })
    })
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-product-template]').forEach((section) => {
    const selectedVariantInput = section.querySelector('[data-product-selected-variant]')
    const variantSelect = section.querySelector('[data-product-variant-select]')
    const quantityInput = section.querySelector('input[name="quantity"]')
    const minusButton = section.querySelector('[data-quantity-minus]')
    const plusButton = section.querySelector('[data-quantity-plus]')
    const leadTimes = Array.from(section.querySelectorAll('[data-product-lead-time]'))

    const updateLeadTime = () => {
      if (!quantityInput || leadTimes.length === 0) return
      const quantity = Number(quantityInput.value || 1)
      leadTimes.forEach((leadTime) => {
        const leadTimeValue = leadTime.querySelector('[data-product-lead-time-value]')
        if (!leadTimeValue) return
        if (leadTime.dataset.bulkApplies !== 'true') return

        const threshold = Number(leadTime.dataset.bulkThreshold || 2)
        leadTimeValue.textContent = quantity > threshold
          ? leadTime.dataset.bulkLeadTime
          : leadTime.dataset.defaultLeadTime
      })
    }

    const priceBlock = section.querySelector('[data-product-price-block]')
    const priceEl = section.querySelector('[data-product-price]')
    const comparePriceEl = section.querySelector('[data-product-compare-price]')
    const savingsEl = section.querySelector('[data-product-savings]')

    const updatePrice = (variantId) => {
      if (!priceBlock || !priceEl) return
      let variantPrices
      try { variantPrices = JSON.parse(priceBlock.dataset.variantPrices || '[]') } catch (e) { return }
      const variant = variantPrices.find((v) => v.id === variantId)
      if (!variant) return

      const formatMoney = (cents) => {
        const dollars = (cents / 100).toFixed(2)
        return '$' + parseFloat(dollars).toLocaleString('en-US', { minimumFractionDigits: 2 })
      }

      priceEl.textContent = formatMoney(variant.price)

      const isOnSale = variant.compare_at_price > variant.price
      const showCompare = priceBlock.dataset.showComparePrice === 'true'
      const showSavings = priceBlock.dataset.showSavings === 'true'

      if (comparePriceEl) {
        comparePriceEl.textContent = formatMoney(variant.compare_at_price)
        comparePriceEl.style.display = isOnSale && showCompare ? '' : 'none'
      }

      if (savingsEl) {
        if (isOnSale && showSavings) {
          const savingsAmount = variant.compare_at_price - variant.price
          const savingsMoney = formatMoney(savingsAmount)
          const msrp = priceBlock.dataset.msrpValue
          if (msrp) {
            const pct = Math.round(savingsAmount * 100 / variant.compare_at_price)
            savingsEl.textContent = pct + '% OFF SPRING SALE!'
          } else {
            const label = priceBlock.dataset.saveLabel || 'Save [[amount]]'
            savingsEl.textContent = label.replace('[[amount]]', savingsMoney)
          }
          savingsEl.style.display = ''
        } else {
          savingsEl.style.display = 'none'
        }
      }
    }

    if (variantSelect && selectedVariantInput) {
      variantSelect.addEventListener('change', () => {
        const variantId = Number(variantSelect.value)
        selectedVariantInput.value = variantId
        updatePrice(variantId)
      })
    }

    if (quantityInput && minusButton) {
      minusButton.addEventListener('click', () => {
        const nextValue = Math.max(1, Number(quantityInput.value || 1) - 1)
        quantityInput.value = nextValue
        updateLeadTime()
      })
    }

    if (quantityInput && plusButton) {
      plusButton.addEventListener('click', () => {
        quantityInput.value = Number(quantityInput.value || 1) + 1
        updateLeadTime()
      })
    }

    if (quantityInput) {
      quantityInput.addEventListener('input', updateLeadTime)
      quantityInput.addEventListener('change', updateLeadTime)
      updateLeadTime()
    }

    const gallery = section.querySelector('[data-product-gallery]')
    if (gallery) {
      const stage = gallery.querySelector('.product-template__media-stage')
      const items = Array.from(gallery.querySelectorAll('.product-template__media-item'))
      const thumbs = Array.from(gallery.querySelectorAll('[data-product-media-thumb]'))
      const prevBtn = gallery.querySelector('[data-product-gallery-prev]')
      const nextBtn = gallery.querySelector('[data-product-gallery-next]')

      let currentIndex = 0

      function setActiveSlide(index) {
        currentIndex = index
        thumbs.forEach((thumb, i) => thumb.classList.toggle('is-active', i === index))
        if (prevBtn) prevBtn.disabled = index === 0
        if (nextBtn) nextBtn.disabled = index === items.length - 1
      }

      setActiveSlide(0)

      thumbs.forEach((thumb, index) => {
        thumb.addEventListener('click', (event) => {
          event.preventDefault()
          const item = items[index]
          if (item && stage) {
            stage.scrollTo({ left: item.offsetLeft, behavior: 'smooth' })
            setActiveSlide(index)
          }
        })
      })

      if (prevBtn) {
        prevBtn.addEventListener('click', () => {
          const target = items[currentIndex - 1]
          if (target && stage) {
            stage.scrollTo({ left: target.offsetLeft, behavior: 'smooth' })
            setActiveSlide(currentIndex - 1)
          }
        })
      }

      if (nextBtn) {
        nextBtn.addEventListener('click', () => {
          const target = items[currentIndex + 1]
          if (target && stage) {
            stage.scrollTo({ left: target.offsetLeft, behavior: 'smooth' })
            setActiveSlide(currentIndex + 1)
          }
        })
      }

      if (items.length > 1 && stage && 'IntersectionObserver' in window) {
        const observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              const index = items.indexOf(entry.target)
              if (index !== -1) setActiveSlide(index)
            }
          })
        }, { root: stage, threshold: 0.5 })

        items.forEach((item) => observer.observe(item))
      }
    }

    section.querySelectorAll('[data-related-swiper-track]').forEach((track) => {
      const swiper = track.closest('.related-swiper')
      if (!swiper) return
      const prevBtn = swiper.querySelector('[data-related-swiper-prev]')
      const nextBtn = swiper.querySelector('[data-related-swiper-next]')
      const cardWidth = () => parseInt(track.style.getPropertyValue('--related-card-width')) || 160

      const updateButtons = () => {
        if (prevBtn) prevBtn.disabled = track.scrollLeft <= 4
        if (nextBtn) nextBtn.disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 4
      }

      track.addEventListener('scroll', updateButtons, { passive: true })
      updateButtons()

      if (prevBtn) {
        prevBtn.addEventListener('click', () => track.scrollBy({ left: -(cardWidth() + 10), behavior: 'smooth' }))
      }
      if (nextBtn) {
        nextBtn.addEventListener('click', () => track.scrollBy({ left: cardWidth() + 10, behavior: 'smooth' }))
      }
    })

    const productForm = section.querySelector('.product-template__form')
    if (productForm) {
      productForm.addEventListener('submit', (event) => {
        if (document.body.dataset.cartType !== 'drawer' || !window.ConexseggCartDrawer) return
        if (event.submitter && event.submitter.name !== 'add') return

        event.preventDefault()
        window.ConexseggCartDrawer.handleAdd(productForm).catch(() => {
          productForm.submit()
        })
      })
    }
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["quote-popup"]) return;
  try {
    
  document.querySelectorAll('[data-quote-popup]').forEach((popup) => {
    const closeButton = popup.querySelector('[data-quote-popup-close]')
    const storageKey = popup.dataset.storageKey || 'quote-popup-dismissed'

    try {
      if (window.sessionStorage.getItem(storageKey) === 'true') {
        popup.hidden = true
      }
    } catch (error) {
      // Keep the popup visible when storage is unavailable.
    }

    if (closeButton) {
      closeButton.addEventListener('click', () => {
        popup.hidden = true
        try {
          window.sessionStorage.setItem(storageKey, 'true')
        } catch (error) {
          // Dismiss visually even if storage is unavailable.
        }
      })
    }
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["smart-recommended-products"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('smart-product-recommendations')) {
    customElements.define(
      'smart-product-recommendations',
      class SmartProductRecommendations extends HTMLElement {
        connectedCallback() {
          if (this.dataset.loaded === 'true' || !this.dataset.url) return

          if ('IntersectionObserver' in window) {
            const observer = new IntersectionObserver((entries, observerInstance) => {
              if (!entries[0].isIntersecting) return
              observerInstance.unobserve(this)
              this.loadRecommendations()
            }, { rootMargin: '0px 0px 360px 0px' })

            observer.observe(this)
          } else {
            this.loadRecommendations()
          }
        }

        loadRecommendations() {
          fetch(this.dataset.url)
            .then((response) => response.text())
            .then((text) => {
              const html = document.createElement('div')
              html.innerHTML = text
              const source = html.querySelector('smart-product-recommendations [data-smart-recommendations-content]')
              const target = this.querySelector('[data-smart-recommendations-content]')

              if (source && target && source.innerHTML.trim().length) {
                target.innerHTML = source.innerHTML
                this.initCarousel()
              }

              this.dataset.loaded = 'true'
            })
            .catch(() => {
              this.dataset.loaded = 'true'
            })
        }

        initCarousel() {
          const track = this.querySelector('[data-smart-recommended-track]')
          const prevButton = this.querySelector('[data-smart-recommended-prev]')
          const nextButton = this.querySelector('[data-smart-recommended-next]')

          if (!track || !prevButton || !nextButton) return

          const getStep = () => {
            const firstItem = track.querySelector('.smart-recommended-products__item')
            if (!firstItem) return 0

            const gap = Number.parseFloat(getComputedStyle(track).gap || '0')
            return firstItem.getBoundingClientRect().width + gap
          }

          function updateState() {
            const atStart = track.scrollLeft <= 0
            const atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 1
            prevButton.disabled = atStart
            nextButton.disabled = atEnd
          }

          prevButton.addEventListener('click', () => {
            track.scrollBy({ left: -getStep(), behavior: 'smooth' })
          })

          nextButton.addEventListener('click', () => {
            track.scrollBy({ left: getStep(), behavior: 'smooth' })
          })

          let scrollTicking = false
          track.addEventListener('scroll', () => {
            if (!scrollTicking) {
              requestAnimationFrame(() => {
                updateState()
                scrollTicking = false
              })
              scrollTicking = true
            }
          })

          updateState()
        }
      }
    )
  }

  } catch(e) { console.error(e); }
})();
})();
